/* 
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview TODO
 */
(function ($g) {
    "use strict";
    var Signal = $g.Signal;
    
    function getDiffMatrix(a1, a2) {
        var matrix = new Array(a1.length+1);

        for(var y=0; y<matrix.length; y++){
            matrix[y] = new Array(a2.length+1);

            for(var x=0; x<matrix[y].length; x++){
                matrix[y][x] = 0;
            }
        }

        for(var y=1; y<matrix.length; y++){
            for(var x=1; x<matrix[y].length; x++){
                var id1 = a1[y-1].id;
                var id2 = a2[x-1].id;
                if(id1&&id2&&id1===id2){
                    matrix[y][x] = 1 + matrix[y-1][x-1];
                } else {
                    matrix[y][x] = Math.max(matrix[y-1][x], matrix[y][x-1]);
                }
            }
        }        
        return matrix;
    }
    
    function ArrayData(source) {
        var Data = $g.Data;
        source = source || [];
        if (!Array.isArray(source)) {
            throw new Error("ArrayData doit recevoir un array en paramètre");
        }
        Signal.call(source);
        var osplice = source.splice;
        var modified = false;
        var watch = source.watch={};
        
        function createData(a) {
            var d;
            if (a instanceof Data) {
                d = a;//L'objet est déjà une instance de data, juste copier
            } else {
                d  = new Data();
                /*if (!a.id) {
                    throw new Error("Tous les items d'un array doivent avoir un identifiant unique");
                }*/
                d.set(a);
            }
            d.bind(function(e) {
                //var index = source.indexOf(d);
                if (watch[e.key]) {
                    modified = true;
                    source.trigger({key: d.id + "." + e.key, data: e.data, old: e.old});                    
                }
            });
            return d;
        }
        
        source.splice = function(start, length) {
            var args = Array.prototype.slice.call(arguments);//convertir argument en array utilisable
            
            //Kill old items            
            for (var i = start; i < start+length; i++) {
                source[i].unbindAll();
            }
            
            //Create Data object
            for (var i = 2; i < args.length; i++) {
                var d = createData(args[i]);
                args[i]=d;
            }
            var r = osplice.apply(source, args);
            source.trigger({
                key: "splice",
                data: args,
                old: r
            });
            return r;
        };
        
        source.push = function() {
            var args = Array.prototype.slice.call(arguments);//convertir argument en array utilisable
            args.unshift(source.length, 0);
            source.splice.apply(source, args);
        };
        
        source.pop = function() {
            throw new Error("unsupported");
        };
        
        source.shift = function() {
            throw new Error("unsupported");
        };
        
        source.unshift = function() {
            throw new Error("unsupported");
        };
        
        source.getIndex = function(id) {
            for (var i = 0; i < source.length; i++) {
                if (source[i].id == id) {
                    return i;
                }
            }
            return -1;
        };
        
        source.get = function(id) {
            var index = source.getIndex(id);
            return source[index];
        };
                
        /**
         * 
         * @param {type} value
         * @returns {undefined}Effectuer le moins de transformation possible pour
         * Rendre nos données identique à la cible
         */
        source.set = function(value) {            
            function applyChanges(x, y) {
                var ax = x-1;
                var ay = y-1;
                //$g.log("applyChanges", x, y);
                //var id1 = source[ax].id;
                //var id2 = value[ay].id;
                if (x>0&&y>0 && source[ax].id&&value[ay].id&&source[ax].id==value[ay].id) {
                    modified = false;
                    source[ax].set(value[ay]);
                    if (modified) {
                        source.trigger({
                            key: "modified",
                            data: value[ay]
                        });
                    }
                    applyChanges(ax, ay);
                    //$g.log("same", source[ax], value[ay]);
                } else {
                    if(y>0 && (x===0 || m[x][ay] >= m[ax][y])){
                        source.splice(x, 0, value[ay]);
                        applyChanges(x, ay);
                        //$g.log("insert", value[ay]);
                    } else if(x>0 && (y===0 || m[x][ay] < m[ax][y])){
                        source.splice(ax, 1);
                        applyChanges(ax, y);
                        //$g.log("delete", source[ax]);
                    } else {
                        //$g.log("in the else!", x, y);
                    }
                }
            }
            
            var m = getDiffMatrix(source, value);
            applyChanges(source.length, value.length);
        };
        
        return source;
    }
    
    $g.ArrayData = ArrayData;
})(PVPGEngine);